import { Role } from 'src/Enum/Report';
import { IEsgDataPlatformFormValues } from '../EsgPlatformFormProvider/types';

export const mapToEsgDataPlatformPayload = (
  formValues: IEsgDataPlatformFormValues
) => {
  const otherDescriptions = (formValues.otherDescriptions ?? []).map(
    (desc) => ({
      id: desc?.id,
      titleTh: desc?.titleTh ?? null,
      titleEn: desc?.titleEn ?? null,
      descriptionTh: desc?.descriptionTh ?? null,
      descriptionEn: desc?.descriptionEn ?? null,
    })
  );
  const introduction =
    formValues.esgDataPlatform?.introduction?.descriptionTh ||
    formValues.esgDataPlatform?.introduction?.descriptionEn
      ? {
          descriptionTh:
            formValues.esgDataPlatform?.introduction?.descriptionTh ?? null,
          descriptionEn:
            formValues.esgDataPlatform?.introduction?.descriptionEn ?? null,
        }
      : null;

  const remark =
    formValues.esgDataPlatform?.remark?.descriptionTh ||
    formValues.esgDataPlatform?.remark?.descriptionEn
      ? {
          descriptionTh:
            formValues.esgDataPlatform?.remark?.descriptionTh ?? null,
          descriptionEn:
            formValues.esgDataPlatform?.remark?.descriptionEn ?? null,
        }
      : null;

  const completedSection = {
    id: formValues.completedSection?.id ?? null,
    isCompletedTh: formValues.completedSection?.isCompletedTh ?? false,
    isCompletedEn: formValues.completedSection?.isCompletedEn ?? false,
    roleStampTh: formValues.completedSection?.roleStampTh ?? Role.NONE,
    roleStampEn: formValues.completedSection?.roleStampEn ?? Role.NONE,
    dateTh: formValues.completedSection?.dateTh ?? undefined,
    dateEn: formValues.completedSection?.dateEn ?? undefined,
  };

  return {
    esgDataPlatform: { introduction, remark },
    otherDescriptions: otherDescriptions,
    completedSection,
  };
};
